import { Card, Text } from "@overmap-ai/blocks"
import { type AssetTypeFieldValues, type Stored } from "@overmap-ai/common"
import { selectUserById } from "@overmap-ai/core"
import { memo } from "react"

import { AssetTimelineItemType } from "../../enums/assets"
import { assetTimelineItemTypeData } from "../../mappings/assets"
import { useAppSelector } from "../../store"
import { formatCompactDate } from "../../utils/date"
import { getUserDisplayLabel } from "../../utils/users"
import { TimelineIconRail } from "../TimelineIconRail/TimelineIconRail"
import type { AssetTimelineSize } from "./typings"

interface AssetFieldValuesTimelineItemProps {
	assetTypeFieldValues: Stored<AssetTypeFieldValues>
	size: AssetTimelineSize
}

export const AssetFieldValuesTimelineItem = memo<AssetFieldValuesTimelineItemProps>((props) => {
	const { assetTypeFieldValues, size } = props

	const createdBy = useAppSelector(selectUserById(assetTypeFieldValues.created_by ?? -1))

	const { icon } = assetTimelineItemTypeData[AssetTimelineItemType.FIELD_VALUES]

	return (
		<div className="flex h-max w-full gap-4">
			<TimelineIconRail icon={icon} size={size} />
			<Card className="flex min-w-0 grow flex-col gap-1" size={size}>
				<Text size={size} accentColor="base">
					<Text highContrast>{getUserDisplayLabel(createdBy)}</Text>
					&nbsp;updated field values
					<Text accentColor="base">
						&nbsp;&#8226;&nbsp;{formatCompactDate(assetTypeFieldValues.submitted_at)}
					</Text>
				</Text>
			</Card>
		</div>
	)
})
AssetFieldValuesTimelineItem.displayName = "AssetFieldValuesTimelineItem"
